export default __webpack_public_path__ + "static/media/ic_arrow_down.a4187ef0.svg";